import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { getPageFromSlug, generateLocalizedUrl } from "@/lib/slugUtils";
import { siteUrl } from "@/lib/siteConfig";
import { trackSEOEvents, validateSchema } from "@/lib/seoAnalytics";

const BreadcrumbStructuredData = () => {
  const { t } = useTranslation(['common']);
  const location = useLocation();
  const baseUrl = siteUrl;
  
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  if (pathSegments.length < 2) return null; // No breadcrumbs for home page
  
  const [lang, slug] = pathSegments;
  const currentPage = getPageFromSlug(slug, lang);
  
  if (!currentPage) return null;
  
  const breadcrumbItems = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": `${baseUrl}/${lang}/`
    },
    {
      "@type": "ListItem", 
      "position": 2,
      "name": t(`navigation.${currentPage}`),
      "item": `${baseUrl}${generateLocalizedUrl(currentPage, lang)}`
    }
  ];

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  };
  
  useEffect(() => {
    try {
      if (validateSchema(breadcrumbSchema)) {
        trackSEOEvents.structuredDataLoaded('BreadcrumbList');
      }
    } catch {}
  }, [location.pathname]);
  
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbStructuredData;